import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import RightPanelTop from './rightPanelTop';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import { showShowCallHistoryModal } from '../../../../actions/modal';
import { Table, Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import moment from 'moment';

export default function ViewCallerHistoryWaitingArea(props) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.videoCallRoomSelected === undefined || props.selectedVideoCallRoomInfo?.length === 0) {
      dispatch(showShowCallHistoryModal(false));
    }
  }, [props.videoCallRoomSelected, props.selectedVideoCallRoomInfo]);

  const closeModal = () => {
    dispatch(showShowCallHistoryModal(false));
  };

  const generateActivitiesMarkUp = (isOnMobile, history) => {
    return history.map((activity, index) => {
      let activeServerTime = moment.utc(activity.serverUtcTime).utcOffset(props.timezone);
      let now = moment();
      let activeDuration = Math.abs(now.diff(activeServerTime, 'minutes'));

      // The bottom(oldest) event will always show the exact time; otherwise show the duration
      let durationText =
        index === history.length - 1
          ? activeServerTime.format('hh:mm:ss a')
          : activeDuration >= 1
          ? activeDuration == 1
            ? APP.LANGUAGE.CallActivityModal.MinsAgo.replace('##mins##', `${activeDuration} min`)
            : APP.LANGUAGE.CallActivityModal.MinsAgo.replace('##mins##', `${activeDuration} mins`)
          : APP.LANGUAGE.CallActivityModal.LessThan1Min;

      return (
        <Table.Row key={index}>
          <Table.Cell singleLine className="align-top-vertical" style={{ borderTop: '0px' }}>
            {durationText}
          </Table.Cell>
          <Table.Cell style={isOnMobile ? {} : { borderTop: '0px' }}>{activity.activity}</Table.Cell>
        </Table.Row>
      );
    });
  };

  console.log(`inside the view caller history`);
  let participantName = props.videoCallRoomSelected[0].participantName
    ? `( ${props.videoCallRoomSelected[0].participantName} )`
    : '';
  return (
    <Modal show={props.showCallHistoryModal} hideWhenClickAway={false} className="view-history-waiting-area">
      <PopupHeader
        title={`${APP.LANGUAGE.ViewOneWaitingArea.ViewHistoryTitle} ${participantName}`}
        helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpCallActivity}
      />
      <div className="content mrbs">
        <div className="main-ui-container">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky ">
                <RightPanelTop closeModal={closeModal} />
              </div>
            </div>
            <Container fluid as={Media} greaterThanOrEqual="computer" style={{ height: '400px', overflowY: 'auto' }}>
              <Table basic className="borderless call-activiy-table">
                <Table.Header className="call-history-table-header color-mid-grey-bg">
                  <Table.Row>
                    <Table.HeaderCell style={{ borderBottom: '0px' }}>Time</Table.HeaderCell>
                    <Table.HeaderCell style={{ borderBottom: '0px' }}>Activity</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {props.videoCallRoomSelected ? generateActivitiesMarkUp(false, props.videoCallRoomSelected) : ''}
                </Table.Body>
              </Table>
            </Container>
            <Container fluid as={Media} at="tablet">
              <Table basic className="borderless call-history-table-on-mobile">
                <Table.Header className="call-history-table-header-on-mobile color-mid-grey-bg">
                  <Table.Row>
                    <Table.HeaderCell style={{ borderBottom: '0px' }}>Time</Table.HeaderCell>
                    <Table.HeaderCell style={{ borderBottom: '0px' }}>Activity</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {props.videoCallRoomSelected ? generateActivitiesMarkUp(true, props.videoCallRoomSelected) : ''}
                </Table.Body>
              </Table>
            </Container>
            <Container fluid as={Media} at="mobile">
              <Table basic className="borderless call-history-table-on-mobile">
                <Table.Body>
                  {props.videoCallRoomSelected ? generateActivitiesMarkUp(true, props.videoCallRoomSelected) : ''}
                </Table.Body>
              </Table>
            </Container>
            <div className="bottom-rail-with-left-and-right-content mrtxl">
              <RightPanelTop closeModal={closeModal} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
